const __WEBPACK_NAMESPACE_OBJECT__ = flarum.reg.get('flarum-realtime', 'forum/RealtimeState');